import { MenuItem, Select } from "@mui/material";

export const EnumArrayField = ({ label, value = [], onChange = () => {}, dataInfo }) => {
    console.log('dataInfo', dataInfo);
    console.log('value', value);
    const values = dataInfo?.options?.values || [];
    const handleChange = e => {
        console.log('e', e);
        onChange(e);
    }
    return (
        <Select
            label={label}
            onChange={handleChange}
            value={value}
            fullWidth
            variant="filled"
            multiple
        >
            {values.map((v, index) => <MenuItem key={index} value={v}>{v}</MenuItem>)}
        </Select>
    );
}